module.exports = __webpack_public_path__ + "img/3.1-klein.f4fd972e.png";